import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';

import { HierarchyPageComponent } from './components/hierarchy-page/hierarchy-page.component';

@NgModule({
  imports: [RouterModule.forChild([
    {
      path: ':orgId/hierarchy',
      component: HierarchyPageComponent,
      data: { breadcrumb: { alias: 'organizationName' } }
    }
  ])],
  exports: [RouterModule],
  providers: []
})
export class HierarchyRoutingModule {
}
